<app-header *ngIf="headerFlag"></app-header>
<div class="fixHight">
<router-outlet>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="rgb(14, 207, 143)" type="ball-scale-multiple">
        <p style="font-size: 20px; color:rgb(14, 207, 143)">Loading...</p>
    </ngx-spinner>
</router-outlet>
</div>

<footer *ngIf="footerFlag" class="mt-3">
    <div class="primary-color">
        <div class="mx-4">
            <div class="row">
                <div class="col-md-4 col-lg-4 footer-about wow fadeInUp animated"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <img class="logo-footer" src="/assets/images/Veggelands-new-logo.png" alt="logo-footer"
                        data-at2x="assets/img/logo.png">
                    <p>
                        We are a young company always looking for new and creative ideas to help you with our products
                        in your everyday work.
                    </p>
                    <!-- <p><a href="#">Our Team</a></p> -->
                </div>
                <div class="col-md-4 col-lg-3 footer-social wow fadeInUp animated"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <h3>Follow us</h3>
                    <p class="d-flex justify-content-around">
                        <a href="#"><i class="fa fa-facebook fa-2x"></i></a>
                        <a href="#"><i class="fa fa-twitter fa-2x"></i></a>
                        <a href="#"><i class="fa fa-google-plus fa-2x"></i></a>
                        <a href="#"><i class="fa fa-instagram fa-2x"></i></a>
                        <a href="#"><i class="fa fa-pinterest fa-2x"></i></a>
                    </p>
                </div>
                <div class="col-md-4 col-lg-4 offset-lg-1 footer-contact wow fadeInDown animated"
                    style="visibility: visible; animation-name: fadeInDown;">
                    <h3>Contact</h3>
                    <p><i class="fa fa-map-marker-alt"></i> Andhri, Mumbai</p>
                    <p><i class="fa fa-phone"></i> Phone: (+91) 333 12 68 347</p>
                    <p><i class="fa fa-envelope"></i> Email: <a href="mailto: help@veggelands.com">
                            help@veggelands.com</a></p>
                    <p><i class="fa fa-skype"></i> Skype: you_online</p>
                </div>

            </div>
        </div>
    </div>
</footer>